import 'regenerator-runtime/runtime';

export default function setupTests() {
  // pass
}
